import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  container: {
    borderRadius: 12,
    overflow: 'hidden',
    position: 'relative',
  },
  base: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: '#F5F5F5',
  },
  shimmer: {
    position: 'absolute',
    top: -50,
    left: -50,
    height: '200%',
    width: '40%',
    backgroundColor: '#FFFFFF99',
  },
});
